export var MediumDestination;
(function (MediumDestination) {
    MediumDestination["ESTIMATE_LANDING"] = "estimate_landing";
    MediumDestination["ESTIMATE_STEP1"] = "estimate_step1";
    MediumDestination["CLASSIFIED_DEPOSIT_LANDING_SELL"] = "classified_deposit_landing_sell";
    MediumDestination["NUTZUNGSDAUER_LANDING"] = "nutzungsdauer_landing";
})(MediumDestination || (MediumDestination = {}));
